export default function isEmpty(value: unknown): boolean {
  return ((value === undefined || value === null) || (Array.isArray(value) && value.length === 0));
}